function CustomTable({ data }) {
  return (
    <>
      {data?.length !== 0 && (
        <div className='table'>
          <table className='my-table'>
            <thead>
              <tr>
                <th>Mall Name</th>
                <th>Roles</th>
                <th>Modules</th>
              </tr>
            </thead>

            <tbody>
              {data?.map((items, indx) => (
                <tr key={indx}>
                  <td>{items?.mallName}</td>
                  <td>{items?.roleName}</td>
                  <td>
                    <ul>
                      {items?.permissions?.map((item) => {
                        if (item.permission) {
                          return <li>{item.description}</li>;
                        }
                        return '';
                      })}
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

export default CustomTable;
